
const shippingOptions = [
  {
    icon: 'ri-truck-line',
    title: 'Standard Shipping',
    time: '5–7',
    unit: 'Business Days',
    price: 'Free on orders over $200',
    description: 'Carefully packaged and shipped via trusted carriers. Tracking number provided within 24 hours of dispatch.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Express Shipping',
    time: '2–3',
    unit: 'Business Days',
    price: '$12.00 flat rate',
    description: 'Priority handling and expedited delivery for when you can&apos;t wait. Available for all domestic orders.',
  },
  {
    icon: 'ri-global-line',
    title: 'International Shipping',
    time: '7–14',
    unit: 'Business Days',
    price: 'Calculated at checkout',
    description: 'We ship to over 50 countries worldwide. Import duties and taxes may apply depending on your location.',
  },
];

const shippingDetails = [
  {
    icon: 'ri-gift-line',
    title: 'Luxury Packaging',
    text: 'Every order arrives in our signature sage-green box with tissue paper, a scented card, and a satin ribbon — ready to gift or enjoy yourself.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Order Tracking',
    text: 'Once your order ships, you&apos;ll receive an email with a tracking link so you can follow your package every step of the way.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Processing Time',
    text: 'Orders placed before 2 PM EST on business days are processed the same day. Weekend orders are processed the following Monday.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Shipping Insurance',
    text: 'All orders are fully insured during transit at no extra cost. If anything arrives damaged, we&apos;ll replace it immediately.',
  },
];

export default function ShippingInfo() {
  return (
    <section id="shipping" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#2E7D32] text-sm tracking-[0.2em] mb-3 font-medium">DELIVERY OPTIONS</p>
          <h2 className="text-3xl font-serif text-gray-900 mb-4">Shipping Information</h2>
          <p className="text-gray-500 text-sm max-w-lg mx-auto leading-relaxed">
            We offer multiple shipping options to suit your needs. All orders are handled with the utmost care to ensure your products arrive in perfect condition.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-16">
          {shippingOptions.map((option) => (
            <div
              key={option.title}
              className="border border-gray-200 rounded-xl p-8 hover:border-[#2E7D32]/40 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-full bg-[#E8F5E9] flex items-center justify-center mb-5 group-hover:bg-[#2E7D32] transition-colors">
                <i className={`${option.icon} text-xl text-[#2E7D32] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">{option.title}</h3>
              <div className="flex items-baseline gap-1.5 mb-3">
                <span className="text-3xl font-serif text-[#2E7D32]">{option.time}</span>
                <span className="text-sm text-gray-500">{option.unit}</span>
              </div>
              <p className="text-sm font-medium text-[#2E7D32] mb-3">{option.price}</p>
              <p className="text-sm text-gray-500 leading-relaxed">{option.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-6">
          {shippingDetails.map((detail) => (
            <div key={detail.title} className="flex gap-4 p-6 bg-[#F1F8E9] rounded-xl">
              <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0 shadow-sm">
                <i className={`${detail.icon} text-lg text-[#2E7D32]`}></i>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-gray-900 mb-1.5">{detail.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{detail.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
